import { Dayjs } from 'dayjs';

import { InquirySourceDto, ProcessSearchRequestDto, ProcessStatusDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { Override } from '@/utils/Override.utilityType.ts';

export type ProcessesListSearchFormModel = Override<
  ProcessSearchRequestDto,
  {
    createdFrom?: Dayjs | null;
    createdTo?: Dayjs | null;
    customerId: SelectSearchOptionModel<number> | null;
    inquirySources: SelectSearchOptionModel<InquirySourceDto>[];
    processContactId: SelectSearchOptionModel<number> | null;
    processCreatorId: SelectSearchOptionModel | null;
    processOwnerId: SelectSearchOptionModel | null;
    statuses: SelectSearchOptionModel<ProcessStatusDto>[];
    updatedFrom?: Dayjs | null;
    updatedTo?: Dayjs | null;
  }
>;

export const initialProcessListSearchFormModel: ProcessesListSearchFormModel = {
  customerId: null,
  fullTextSearchInput: '',
  inquirySources: [],
  processContactId: null,
  processCreatorId: null,
  processOwnerId: null,
  statuses: [],
};
